import { render, staticRenderFns } from "./thank_you.vue?vue&type=template&id=3d84e968"
import script from "./thank_you.vue?vue&type=script&lang=js"
export * from "./thank_you.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports